import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';
import CumulativeWinnersWidgetComponent from './cumulative-winners-widget-component';
import CumulativeWinnersHistoryComponent from './components/cumulative-history-component';

export default angular
  .module('cumulative-winners-widget', [])
  .component('cumulativeWinnersWidget', new CumulativeWinnersWidgetComponent())
  .component('cumulativeHistory', new CumulativeWinnersHistoryComponent())
  .config([
    '$stateProvider',
    function configuration($stateProvider) {
      $stateProvider.state('cumulativeWinners-history', {
        parent: 'arw',
        url: '/cumulative-winners/history/:retailerNo?',
        template: '<cumulative-history></cumulative-history>',
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Cashing History')));
            },
          ],
        },
      });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/cumulative-winners/cumulative-winners-widget-module.js